import React from "react";
import { isTemplateExisits } from "../../../../utils";
import Config from "../../../../config/app.config.json";

type OfferProps = {
  offerContent?: any;
};
const OffersComponent = isTemplateExisits(Config.Home.Plans)
  ? require(`./${Config.Home.Offers.template}_Offers`).default
  : null;

function Offers(props: OfferProps) {
  const { offerContent } = props;

  return <OffersComponent offerContent={offerContent} />;
}

export default Offers;
